import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { HERO_IMAGE_URL } from '../utils/headMeta';
import { PRODUCT_FACTS } from './salesData';
const HERO_IMG = HERO_IMAGE_URL;
/** Intrinsic size of the mockup — used to reserve layout space (avoids CLS). */
const HERO_IMG_WIDTH = 1209;
const HERO_IMG_HEIGHT = 1298;
export function Hero() {
  return <section className="relative overflow-hidden bg-cream" data-id="element-120" data-mp="1297ahz3tqr77">
      <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[32rem] -translate-x-1/2 rounded-full bg-sand blur-3xl" aria-hidden data-id="element-121" data-mp="128pgza8jqr2z" />

      <div className="relative mx-auto max-w-xl px-5 pb-6 pt-3.5 text-center sm:max-w-3xl sm:pb-10 sm:pt-8" data-id="element-122" data-mp="sa9szg4tfxxp">
        <div className="animate-hero-copy" data-id="element-123" data-mp="nbey3ftkqix8">
          <p className="font-display text-[0.6rem] font-bold uppercase tracking-editorial text-gold-deep sm:text-[0.7rem]" data-id="element-124" data-mp="3d1ik78o21amw">
            Megapack 6 en 1 · Recetario digital
          </p>
          <h1 className="mt-2 font-display text-[1.6rem] font-extrabold uppercase leading-[1.05] tracking-tight text-charcoal sm:text-[2.6rem]" data-id="element-125" data-mp="384s6grzq2r4n">
            500+ Recetas <span className="mark-yellow" data-id="element-126" data-mp="3o6ap3tgx82yw">Keto + Sin TACC</span>
          </h1>
          <p className="mx-auto mt-3 max-w-[28ch] font-display text-[1.02rem] font-bold leading-[1.25] tracking-tight text-charcoal sm:max-w-[38ch] sm:text-[1.45rem]" data-id="element-127" data-mp="39autvl4lu10x">
            Comé rico todos los días sin salirte de tu alimentación
          </p>
        </div>

        <div className="relative mx-auto mt-3 w-[88%] max-w-[360px] sm:mt-6 sm:w-full sm:max-w-[560px]" data-id="element-128" data-mp="30g6kbirzxx6b">
          <span className="absolute inset-x-6 bottom-6 top-8 -z-0 rounded-[3rem] bg-gold-soft blur-2xl" aria-hidden data-id="element-129" data-mp="2qjv80ssep7bv" />
          <img src={HERO_IMG} alt="Colección 500+ Recetas Keto + Sin TACC: los 6 tomos del megapack" width={HERO_IMG_WIDTH} height={HERO_IMG_HEIGHT} fetchPriority="high" decoding="async" sizes="(max-width: 640px) 88vw, 560px" style={{
          aspectRatio: `${HERO_IMG_WIDTH} / ${HERO_IMG_HEIGHT}`
        }} className="animate-hero-media relative block h-auto w-full object-contain drop-shadow-[0_22px_30px_rgba(25,23,19,0.18)]" data-id="element-130" data-mp="2vjq02znx42yi" />
        </div>

        <p className="mx-auto mt-3 max-w-[36ch] font-sans text-[0.86rem] font-medium leading-snug text-taupe sm:max-w-[54ch] sm:text-[1rem]" data-id="element-131" data-mp="dd5cymj2tf32">
          Más de <strong className="font-bold text-charcoal" data-id="element-132" data-mp="1azkutpff0er5">500 ideas fáciles</strong> para
          desayunos, meriendas, almuerzos, cenas, snacks, panes y mucho más, con ingredientes que
          conseguís en Argentina.
        </p>

        <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-2 gap-y-1" data-id="element-133" data-mp="114swukhx7pvu">
          {PRODUCT_FACTS.map((fact, i) => <React.Fragment key={fact} data-id="element-134" data-mp="3ltgltmwy8kmr" data-mpi={i}>
              {i > 0 && <span className="h-1 w-1 rounded-full bg-gold" aria-hidden data-id="element-135" data-mp="3lu9vowr7fq94" />}
              <li className="font-display text-[0.66rem] font-bold uppercase tracking-[0.06em] text-charcoal sm:text-[0.78rem]" data-id="element-136" data-mp="3hqam6y4cdrp9">
                {fact}
              </li>
            </React.Fragment>)}
        </ul>

        <PriceBlock className="mt-3.5" layout="inline" size="sm" data-id="element-137" data-mp="21b61vs3mqqk0" />

        <div className="mt-3 flex justify-center" data-id="element-138" data-mp="268y69llgo553">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-139" data-mp="2686946c7tzcp" />
        </div>

        <p className="mt-2 font-sans text-[0.72rem] font-medium text-taupe" data-id="element-140" data-mp="2b20pp0wixy7k">
          Producto digital · Pago único · Acceso inmediato
        </p>
      </div>
    </section>;
}